import {
  ThemeProvider as MuiThemeProvider,
  ScopedCssBaseline,
  createTheme,
} from '@mui/material';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { useTranslation } from 'react-i18next';
import {
  MuiAccordion,
  MuiAccordionDetails,
  MuiAccordionSummary,
  MuiAlert,
  MuiAvatar,
  MuiButton,
  MuiChip,
  MuiSelect,
  MuiTab,
  MuiTableCell,
  MuiTableRow,
  MuiTabs,
  MuiToggleButtonGroup,
  MuiStepConnector,
  MuiStep,
  MuiCheckbox,
} from './components';
import { MuiTextField } from './components/TextField';
import { palette } from './palette';
import { typography } from './typography';
interface ThemeProviderProps {
  children: React.ReactNode;
}

const theme = createTheme({
  palette,
  typography,
  components: {
    MuiAccordion,
    MuiAccordionSummary,
    MuiAccordionDetails,
    MuiAlert,
    MuiAvatar,
    MuiButton,
    MuiChip,
    MuiTabs,
    MuiTab,
    MuiTableCell,
    MuiTableRow,
    MuiTextField,
    MuiSelect,
    MuiToggleButtonGroup,
    MuiStepConnector,
    MuiStep,
    MuiCheckbox,
  },
});

function ThemeProvider({ children }: ThemeProviderProps) {
  const { i18n } = useTranslation();
  return (
    <ScopedCssBaseline sx={{ height: 1 }}>
      <MuiThemeProvider theme={theme}>
        <LocalizationProvider
          dateAdapter={AdapterLuxon}
          adapterLocale={i18n.language}
        >
          {children}
        </LocalizationProvider>
      </MuiThemeProvider>
    </ScopedCssBaseline>
  );
}

export { ThemeProvider };
